export const SIGNATURE_NOTE_PLACEHOLDER = "[Digital Signature Provided]";

const extractBlobFileName = (url) => {
    const blobName = decodeURIComponent(url.split('/').pop());
    const uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_/i;
    const match = blobName.match(uuidRegex);
    if (match) {
        return blobName.slice(blobName.indexOf(match[0]) + match[0].length);
    }
    return blobName;
};

export const SignatureAnswerRenderer = (params) => {
    if (params.value?.startsWith('data:image')) {
        return (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
                <img
                    src={params.value}
                    alt="Signature"
                    style={{
                        maxHeight: '35px',
                        maxWidth: '200px',
                        objectFit: 'contain'
                    }}
                />
            </div>
        );
    }

    if (params.value?.includes('.blob.core.windows.net')) {
        const fileName = extractBlobFileName(params.value);
        return (
            <a href={params.value} target="_blank" rel="noreferrer">
                {fileName}
            </a>
        );
    }

    return <span>{params.value}</span>;
};

export const signatureExportCellCallback = (params) => {
    const value = params.value;
    if (typeof value === 'string' && value.startsWith('data:image')) {
        return SIGNATURE_NOTE_PLACEHOLDER;
    }
    return value;
};

export default SignatureAnswerRenderer;
